import { useEffect, useRef } from 'react'
import lottie from 'lottie-web'
import { useNavigate } from 'react-router-dom'
import { Modal as BootstrapModal } from 'react-bootstrap'
import confetti from '../connect4/confetti.json'
import './Modal.scss'
import { isMobile } from '../../../utils/_helper'
import DarkModeButton from '../../../components/common/Buttons/DarkModeButton'
import EventTracker from '../../../utils/EventTracker'

const Modal = ({
  feature,
  show,
  type,
  kind,
  heading,
  intro,
  example,
  difficulty,
  stats,
  done,
  reset,
  shareable = false,
  win = false,
  share = null,
}) => {
  const confettiAnimation = useRef(null)
  const navigate = useNavigate()

  useEffect(() => {
    win &&
      lottie.loadAnimation({
        container: confettiAnimation.current,
        renderer: 'svg',
        loop: 1,
        autoplay: true,
        animationData: confetti,
      })
  }, [win])

  useEffect(() => {
    if (type == 'END') {
      const properties = {
        Type: 'Games completed',
        Game: kind,
      }
      EventTracker.instance.trackEvent('Games completed', properties)
    }
  }, [type])

  const flutterShareHandler = () => {
    window.flutter_inappwebview.callHandler('gameEvent_shareGame', share)
  }

  return (
    <BootstrapModal
      show={show}
      backdropClassName='modal-game-backdrop'
      size='sm'
      centered
      className='modal-game'
    >
      <BootstrapModal.Body>
        <div className='game-modal'>
          {type === 'START' && (
            <div className='game-modal-start'>
              <div className='game-modal-start-heading'>
                {heading ? heading : 'How to play:'}
              </div>
              <div className='game-modal-start-body'>{intro}</div>
              <div className='game-modal-start-example'>{example}</div>
              <div className='game-modal-start-difficulty'>{difficulty}</div>
              <div className='game-modal-start-footer'>
                {isMobile() ? (
                  <DarkModeButton
                    label='START'
                    innerStyle={{ padding: `0 2rem` }}
                    onClick={() => done()}
                  />
                ) : (
                  <button
                    type='button'
                    className='btn game-modal-button'
                    onClick={() => done()}
                  >
                    START
                  </button>
                )}
              </div>
            </div>
          )}
          {type === 'END' && (
            <div className='game-modal-end'>
              <div className='game-modal-end-stats'>
                {kind === 'MEMORY' && (
                  <>
                    {Object.keys(stats).map((key) => (
                      <div
                        key={`game-modal-end-stats-${key}`}
                        className='game-modal-end-stats-memory'
                      >
                        <div className='game-modal-end-stats-memory-text'>
                          {`${key.charAt(0).toUpperCase()}${key.slice(1)}`}
                        </div>
                        <div className='game-modal-end-stats-memory-value'>
                          {stats[key]}
                        </div>
                      </div>
                    ))}
                  </>
                )}
                {kind === 'COLOR' && (
                  <>
                    <div className='game-modal-end-stats-color-text'>
                      Your Score is:
                    </div>
                    <div className='game-modal-end-stats-color-score'>
                      {stats.score}
                    </div>
                  </>
                )}
                {kind === 'WHACK_A_MOLE' && (
                  <>
                    <div className='game-modal-end-stats-color-text'>
                      Your Score is:
                    </div>
                    <div className='game-modal-end-stats-color-score'>
                      {stats.score}
                    </div>
                  </>
                )}
                {kind === 'CONNECT4' && (
                  <>
                    {win && (
                      <div
                        className='game-modal-end-overlay'
                        ref={confettiAnimation}
                      />
                    )}
                    <div className='game-modal-end-stats-connect4-text'>
                      <div className='game-modal-close'>
                        <button
                          onClick={() =>
                            window.flutter_inappwebview.callHandler(
                              'gameCloseEvent_closeGame',
                              '*'
                            )
                          }
                        >
                          <img
                            src='https://cdn.mindpeers.co/dark-mode/site-icons/new-dashboard-icons/cross.svg'
                            alt='close'
                          />
                        </button>
                      </div>
                      {stats.outcome === 'WIN' ? (
                        <div className='game-win'>
                          <div className='game-win-emoji'>
                            <img
                              src='https://cdn.mindpeers.co/games/connect_four/assets/celebration_emoji.png'
                              alt='GAME WON'
                            />
                          </div>
                          You win! Share your victory with friends
                        </div>
                      ) : stats.outcome === 'DRAW' ? (
                        `Woah, that was intense. It's a tie!`
                      ) : (
                        'Uh-oh. Better luck next time!'
                      )}
                    </div>
                  </>
                )}
              </div>
              <div className='game-modal-end-footer'>
                {!shareable &&
                  !win &&
                  (isMobile() ? (
                    <DarkModeButton
                      label={feature === 'GAME' ? 'GO BACK' : 'NEXT'}
                      style={{ paddingRight: '1rem' }}
                      innerStyle={{ padding: `0 2rem` }}
                      onClick={() => done()}
                    />
                  ) : (
                    <button
                      type='button'
                      className='btn game-modal-button'
                      onClick={() => done()}
                    >
                      {feature === 'GAME' ? 'GO BACK' : 'NEXT'}
                    </button>
                  ))}
                {isMobile() ? (
                  <DarkModeButton
                    label='PLAY AGAIN'
                    style={{ paddingRight: shareable && win && '1rem' }}
                    innerStyle={{ padding: `0 1.5rem` }}
                    onClick={() => reset()}
                  />
                ) : (
                  <button
                    type='button'
                    className='btn game-modal-button'
                    onClick={() => reset()}
                  >
                    PLAY AGAIN
                  </button>
                )}
                {shareable &&
                  win &&
                  (isMobile() ? (
                    <DarkModeButton
                      label='SHARE'
                      innerStyle={{ padding: `0 1.5rem` }}
                      onClick={() => flutterShareHandler()}
                    />
                  ) : (
                    <button
                      type='button'
                      className='btn game-modal-button'
                      onClick={() => share()}
                    >
                      SHARE
                    </button>
                  ))}
              </div>
            </div>
          )}
        </div>
      </BootstrapModal.Body>
    </BootstrapModal>
  )
}

export default Modal
